module.exports = __webpack_public_path__ + "static/media/error_404.b9e40ade.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error_404.svg
// module id = 1038
// module chunks = 0